import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'box-shimmer',
  templateUrl: './box-shimmer.component.html',
  styleUrls: ['./box-shimmer.component.scss']
})
export class BoxShimmerComponent implements OnInit {
  public boxHeight = '200px';
  public boxWidth = '200px';
  constructor() { }

  ngOnInit(): void {
  }

}
